import { Building2 } from 'lucide-react';
import { FormData } from '../../types';

interface BusinessDetailsProps {
  formData: FormData;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showErrors: boolean;
}

export const BusinessDetails = ({ formData, handleInputChange, showErrors }: BusinessDetailsProps) => {
  return (
    <div className="space-y-6">
      <h2 className="text-xl sm:text-2xl font-semibold flex items-center gap-3 text-blue-900">
        <Building2 className="text-[#6366F1]" />
        Business Details
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Business Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="businessName"
            value={formData.businessName}
            onChange={handleInputChange}
            className="input-field"
            placeholder="Enter your business name"
          />
          {showErrors && !formData.businessName.trim() && (
            <p className="mt-2 text-sm text-red-600">Business name is required</p>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Industry <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="industry"
            value={formData.industry}
            onChange={handleInputChange}
            className="input-field"
            placeholder="e.g., Technology, Healthcare, Retail"
          />
          {showErrors && !formData.industry.trim() && (
            <p className="mt-2 text-sm text-red-600">Industry is required</p>
          )}
        </div>
      </div>
    </div>
  );
};